export default __webpack_public_path__ + "d15f2b4ca3895313c2e037af9b82d3f5.svg";